import { render, staticRenderFns } from "./ActivityAllocationEditor.vue?vue&type=template&id=1945fa3a&scoped=true&"
import script from "./ActivityAllocationEditor.vue?vue&type=script&lang=js&"
export * from "./ActivityAllocationEditor.vue?vue&type=script&lang=js&"
import style0 from "./ActivityAllocationEditor.vue?vue&type=style&index=0&id=1945fa3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945fa3a",
  null
  
)

export default component.exports